import React from 'react';

const SuccessModal = ({ show, onClose, title, message, type = 'success' }) => {
    if (!show) return null;

    // Inline styles to ensure it works without external CSS dependencies
    const styles = {
        overlay: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
            backdropFilter: 'blur(5px)'
        },
        modal: {
            backgroundColor: '#fff',
            borderRadius: '15px',
            padding: '0',
            width: '90%',
            maxWidth: '400px',
            boxShadow: '0 10px 25px rgba(0,0,0,0.2)',
            position: 'relative',
            overflow: 'hidden',
            animation: 'fadeInUp 0.3s ease-out'
        },
        header: {
            backgroundColor: type === 'success' ? '#8BAE66' : '#dc3545',
            padding: '20px',
            textAlign: 'center',
            color: 'white'
        },
        icon: {
            fontSize: '48px',
            lineHeight: '1',
            marginBottom: '10px',
            display: 'block'
        },
        body: {
            padding: '30px 20px',
            textAlign: 'center'
        },
        title: {
            margin: '0 0 10px 0',
            fontSize: '24px',
            fontWeight: '600',
            color: '#333'
        },
        message: {
            margin: '0 0 25px 0',
            color: '#666',
            lineHeight: '1.5'
        },
        button: {
            backgroundColor: type === 'success' ? '#8BAE66' : '#dc3545',
            color: 'white',
            border: 'none',
            padding: '12px 30px',
            borderRadius: '50px',
            fontSize: '16px',
            cursor: 'pointer',
            transition: 'opacity 0.2s',
            fontWeight: '500'
        }
    };

    return (
        <div style={styles.overlay} onClick={onClose}>
            <div style={styles.modal} onClick={e => e.stopPropagation()}>
                <div style={styles.header}>
                    <div style={styles.icon}>
                        {type === 'success' ? '✓' : '✕'}
                    </div>
                </div>
                <div style={styles.body}>
                    <h3 style={styles.title}>{title}</h3>
                    <p style={styles.message}>{message}</p>
                    <button
                        style={styles.button}
                        onClick={onClose}
                        onMouseOver={e => e.target.style.opacity = '0.9'}
                        onMouseOut={e => e.target.style.opacity = '1'}
                    >
                        OK
                    </button>
                </div>
            </div>
            <style>{`
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
        </div>
    );
};

export default SuccessModal;